<div class="d-flex flex-no-wrap justify-content-center align-items-center gap-0 gap-lg-5 mt-2 mt-md-0">
  <a
    *ngIf="isGrowth"
    class="d-none d-lg-block link-dark"
    target="_blank"
    [href]="bedarfsradarUrl"
    [ngbTooltip]="'leads' | translate"
  >
    <i class="fa-solid fa-bullseye-pointer"></i>
  </a>
  <a
    *ngIf="portalSettings.links.urls.help"
    class="d-none d-lg-block link-dark"
    target="_blank"
    [href]="portalSettings.links.urls.help"
    [ngbTooltip]="'help' | translate"
  >
    <i class="fa-solid fa-question-circle"></i>
  </a>
  <base-notifications></base-notifications>
  <i
    class="fa-solid fa-user d-lg-none fs-3 ms-5 pointer"
    (click)="openUserMenuSidebar.emit()"
  ></i>
  <base-language-switch
    class="d-none d-lg-block"
    [shouldReloadTranslations]="true"
  ></base-language-switch>
  <div
    class="k-dropdown"
    (baseClickOutside)="close()"
  >
    <div
      class="user-nav d-none d-lg-flex align-items-center py-2"
      (click)="toggle()"
    >
      <base-avatar
        [image]="userAvatar || ''"
        [size]="avatarSize"
        class="mx-2"
      ></base-avatar>
      <div class="d-flex flex-column text-start">
        <span class="bold-font">{{ userName }}</span>
        <span class="light-font">{{ companyData?.primaryData?.name }}</span>
      </div>
      <i
        class="fa-solid fa-fw me-1 bold-font"
        [ngClass]="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"
      ></i>
    </div>
    <div
      class="user-nav-menu"
      *ngIf="isOpen"
      (click)="close()"
    >
      <ng-container *ngTemplateOutlet="menu"></ng-container>
    </div>
  </div>
</div>

<ng-template #menu>
  <ul class="user-nav-body list-unstyled mx-3 my-2">
    <li class="d-flex align-items-center gap-2">
      <base-avatar
        [image]="companyData?.logo?.data || ''"
        [size]="avatarSize"
        [isCompany]="true"
      ></base-avatar>
      <div class="col d-flex flex-column user-nav-first-row">
        <span class="bold-font">{{ companyData?.primaryData?.name }}</span>
        <span class="light-font">{{ position }}</span>
      </div>
    </li>
    <hr class="my-2" />
    <ng-container *ngFor="let item of userMenuItems">
      <li
        class="text-uppercase bold-font"
        *ngIf="item.id !== 60 || (item.id === 60 && signDigital)"
      >
        <a [routerLink]="item.url">
          {{ item.title | translate }}
        </a>
      </li>
    </ng-container>
    <hr class="my-2" />
    <li>
      <a
        class="user-nav-logout bold-font"
        (click)="logout($event)"
      >
        <span>{{ 'auth.logout' | translate }}</span>
        <i class="fa-solid fa-fw fa-chevron-right"></i>
      </a>
    </li>
  </ul>
</ng-template>
